const AvatarCompany = ({ name, bigger, borders }) => {
  return (
    <div
      className={
        'rounded-8 uppercase bg-primary text-white font-medium text-sm flex items-center justify-center ' +
        (bigger
          ? 'w-[72px] min-w-[72px] h-[72px]'
          : borders
          ? 'w-[36px] min-w-[36px] h-[36px]'
          : 'w-32 min-w-32 h-32') +
        (borders ? ' border-2 border-white' : '')
      }
    >
      {name?.substring(0, 1)}
    </div>
  )
}

export default AvatarCompany
